import { SCALE } from '../../constants';
import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  withStyles,
} from '@material-ui/core';
import React from 'react';

export const DEFAULT = [
  {
    color: '#BEEEC7',
    title: 'Normal',
  },
  {
    color: '#F9E1A1',
    title: 'High Normal',
  },
  {
    color: '#FFBCB7',
    title: 'Grade 1 Hypertension',
  },
  {
    color: '#FF695E',
    title: 'Grade 2 Hypertension',
  },
  {
    color: '#E8DEFF',
    title: 'Isolated Systolic Hypertension',
  },
];

const CustomList = withStyles({
  root: {
    '& .MuiTypography-body1': {
      color: '#333',
      fontSize: 12 * SCALE,
    },

    '& .MuiListItem-root': {
      paddingTop: 5 * SCALE,
      paddingBottom: 5 * SCALE,
      gap: 25 * SCALE,
    },
    '& .MuiListItemText-root': {
      margin: 0,
    },
    '& .MuiListItemIcon-root': {
      minWidth: 'unset',
    },
  },
})(List);

const LegendsOfChartCom = ({ data = DEFAULT }) => {
  return (
    <CustomList>
      {data.map((it, inx) => (
        <ListItem key={`${it.title}-${inx}`} disableGutters>
          <ListItemIcon>
            <Box
              borderRadius={4 * SCALE}
              width={40 * SCALE}
              height={20 * SCALE}
              bgcolor={it.color}
            />
          </ListItemIcon>
          <ListItemText primary={it.title} />
        </ListItem>
      ))}
    </CustomList>
  );
};

export default LegendsOfChartCom;
